import { ALL_EXAMS, ALL_STATES } from '@cont/Compete/constants';
import create from 'zustand';
import createStoreSelectors from '../utils/createStoreSelector';

const useStore = create((set) => ({
  examFilter: ALL_EXAMS,
  stateFilter: ALL_STATES,
  isLeaderboardDialogOpen: false,
  selectedDuration: null,

  setExamFilter: (data) => {
    set((state) => ({
      ...state,
      examFilter: data
    }));
  },
  setStateFilter: (data) => {
    set((state) => ({
      ...state,
      stateFilter: data
    }));
  },
  setLeaderboardDialogState: (data) => {
    set((state) => ({
      ...state,
      isLeaderboardDialogOpen: data
    }));
  },

  setSelectedDuration: (duration) =>
    set((state) => ({
      ...state,
      selectedDuration: duration
    }))
}));

const useCompete = createStoreSelectors(useStore);

export default useCompete;
